<template>
<v-menu offset-y open-on-hover>
  <template #activator="{ on, attrs }">
    <v-btn v-on="on" v-bind="attrs" text>
      Users
    </v-btn>
  </template>
  <v-list>
    <v-list-item
      v-for="user in users" :key="user.id"
      dense
      :to="{name: 'User', params: {id: user.id}}"
    >
      <v-list-item-title>{{ user.name }}</v-list-item-title>
    </v-list-item>
  </v-list>
</v-menu>
</template>

<script>
export default {
  name: "Usersmenu",
  data() {
    return {
      users: [],
    }
  },
  inject: ["httpClient"],
  mounted() {
    this.load()
  },
  methods: {
    async load() {
      this.users = await this.httpClient.loadUsers()
    },
  },
}
</script>
